import * as THREE from 'three';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';
import { makeRailProfile } from '../scene/rails';
import { SD_TRACK_PITCH, sdTrackDepth } from './sd150Layout';

const rectangle = (x, y, w, h, hole = false) => {
  const shape = hole ? new THREE.Path() : new THREE.Shape();
  shape.moveTo(x, y); shape.lineTo(x + w, y); shape.lineTo(x + w, y + h); shape.lineTo(x, y + h); shape.closePath();
  return shape;
};

// Only the two-track SD150 section is supplied CAD. Wider rails are visibly
// qualified conceptual hollow modules, using the SD150 78.5 mm lane spacing.
export function sd150TrackProfile(count, type, length, height, frame, materials) {
  if (count === 2) {
    const source = makeRailProfile(type, length, frame, false, materials);
    if (type === 'head') source.position.y = height;
    return source;
  }
  const group = new THREE.Group(), shapes = [];
  for (let i = 0; i < count; i++) {
    const z = (i - (count - 1) / 2) * SD_TRACK_PITCH;
    const chamber = rectangle(z - .03575, 0, .0715, .02);
    chamber.holes.push(rectangle(z - .03375, .002, .0675, .016, true)); shapes.push(chamber);
    if (type === 'sill') {
      shapes.push(rectangle(z - .004, .02, .008, .0067), rectangle(z - .0105, .0267, .021, .0008));
    } else {
      shapes.push(rectangle(z - .03575, .02, .002, .03), rectangle(z + .03375, .02, .002, .03));
    }
  }
  const parts = shapes.map(shape => {
    const geometry = new THREE.ExtrudeGeometry(shape, { depth: length, steps: 1, bevelEnabled: false });
    geometry.translate(0, 0, -length / 2); geometry.rotateY(Math.PI / 2);
    if (type === 'head') { geometry.rotateX(Math.PI); geometry.translate(0, height, 0); }
    return geometry;
  });
  const mesh = new THREE.Mesh(mergeGeometries(parts, false), frame); parts.forEach(g => g.dispose());
  mesh.castShadow = true; mesh.receiveShadow = true; group.add(mesh);
  group.userData = { profileSource: 'conceptual-multi-track', trackCount: count, profileDepth: sdTrackDepth(count) * 1000 };
  return group;
}